import React from "react";

import { Input } from "~/components/input";
import { useScope } from "~/tools/impulse";

import type { WidgetYAxisLabel } from "./form-state";

export interface WidgetYAxisLabelFieldProps {
	className?: string;
	disabled?: boolean;
	name: string;
	label: WidgetYAxisLabel;
}

export const WidgetYAxisLabelField: React.FC<WidgetYAxisLabelFieldProps> = ({ className, disabled, name, label }) => {
	const scope = useScope();

	return (
		<Input
			className={className}
			disabled={disabled}
			name={name}
			onChange={(event) => label.setInput(event.target.value)}
			placeholder="Default"
			value={label.getInput(scope)}
		/>
	);
};
